import { Text } from "@chakra-ui/react";

type HeadingProps = {
  title?: string;
  color?: string;
  fontWeight?: number;
  fontSize?: string;
  flex?: number;
  paddingLeft?: number;
};

const Heading = ({title= 'Suggested for You', color='primary.grey', fontWeight=500, fontSize='4xl', ...rest}: HeadingProps) => {
  return (
      <Text {...rest} color={color} fontSize={fontSize}  fontWeight={fontWeight}>{title}</Text>
  );
};

export { Heading };
